import padStart from 'lodash/padStart'

/**
 * Formats the given `seconds` as HH:mm:ss, for example 01:23:30.
 *
 * @param seconds number of seconds
 * @param options.showHours if true (default), hours will be always included, if `auto` then only when the value is longer than 1 hour
 * @param options.showMs if true, also show milliseconds (e.g. `01:23:30.123`)
 */
export function formatTime(
  seconds: number,
  options?: { showHours?: boolean | 'auto'; showMs?: boolean },
) {
  let { showHours = true } = options ?? {}

  const HH = padStart(`${Math.floor(seconds / 60 / 60)}`, 2, '0')
  const mm = padStart(`${Math.floor(seconds / 60) % 60}`, 2, '0')
  const ss = padStart(`${Math.floor(seconds) % 60}`, 2, '0')
  const SSS = padStart(
    `${Math.floor((seconds - Math.floor(seconds)) * 1000)}`,
    3,
    '0',
  )

  if (showHours === 'auto') showHours = HH !== '00'

  return (
    (showHours ? `${HH}:${mm}:${ss}` : `${mm}:${ss}`) +
    (options?.showMs ? `.${SSS}` : '')
  )
}
